import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, LogIn } from "lucide-react";
import { useAdminAuth } from "../../context/AdminAuthContext";

export default function AdminLogin() {
  const { login, isAuthed } = useAdminAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthed) navigate("/admin/dashboard");
  }, [isAuthed, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--navy-900)] px-5">
      <div className="w-full max-w-[420px]">
        <div className="mb-8 flex items-center justify-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-[10px] bg-white text-[var(--navy)] font-extrabold text-lg">O</div>
          <div className="leading-none">
            <div className="font-display text-[18px] font-extrabold text-white">Odor Removal</div>
            <div className="mt-[3px] text-[10px] font-semibold tracking-[0.22em] text-slate-400">DIRECTORY · ADMIN</div>
          </div>
        </div>

        <form onSubmit={submit} className="rounded-2xl bg-white p-8 shadow-2xl">
          <h1 className="font-display text-[24px] font-extrabold text-[var(--ink)]">Admin sign in</h1>
          <p className="mt-1 text-[14px] text-slate-500">Manage your website content.</p>

          {error && <div className="mt-5 rounded-lg bg-rose-50 px-4 py-3 text-[13px] font-medium text-rose-600">{error}</div>}

          <label className="mt-6 block text-[13px] font-semibold text-[var(--ink)]">Username</label>
          <div className="mt-1.5 flex items-center gap-2 rounded-xl border border-slate-200 px-3.5 focus-within:border-[var(--brand-blue)]">
            <User size={17} className="text-slate-400" />
            <input value={username} onChange={(e) => setUsername(e.target.value)} className="h-12 flex-1 bg-transparent text-[15px] outline-none" placeholder="admin" autoComplete="username" />
          </div>

          <label className="mt-4 block text-[13px] font-semibold text-[var(--ink)]">Password</label>
          <div className="mt-1.5 flex items-center gap-2 rounded-xl border border-slate-200 px-3.5 focus-within:border-[var(--brand-blue)]">
            <Lock size={17} className="text-slate-400" />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 flex-1 bg-transparent text-[15px] outline-none" placeholder="••••••••" autoComplete="current-password" />
          </div>

          <button disabled={loading} className="mt-7 flex w-full items-center justify-center gap-2 rounded-xl bg-[var(--brand-blue)] px-5 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-[var(--brand-blue-hover)] disabled:opacity-60">
            <LogIn size={17} /> {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
